import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalFunctionService {
  public capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  public formatDate(date: any): string {
    if (typeof date !== 'undefined') {
      const dateString = new Date(date);
      const dateS = dateString.toLocaleDateString('fr-FR', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });

      return this.capitalizeFirstLetter(dateS);
    }

    throw new Error('QuotationComponent : Could not format date');
  }

  //
  // ─── DOWNLOAD ───────────────────────────────────────────────────────────────────
  //

  private download(file, fileName) {
    const a = document.createElement('a');
    a.href = file;
    a.style.display = 'none';
    a.download = fileName;
    a.setAttribute('download', fileName);

    document.body.appendChild(a);

    a.click();

    a.parentNode.removeChild(a);
  }

  public getMimeTypeFromName(name: string): string {
    const extIndex = name.lastIndexOf('.');
    const ext = name.substring(extIndex + 1).toLowerCase();

    switch (ext) {
      case 'pdf':
        return 'application/pdf';

      case 'jpg':
      case 'jpeg':
        return 'image/jpeg';

      case 'gif':
        return 'image/gif';

      case 'png':
        return 'image/png';

      case 'avi':
        return 'video/avi';

      case 'mov':
        return 'video/quicktime';

      case 'zip':
        return 'application/zip';

      case 'docx':
        return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

      case 'doc':
        return 'application/msword';

      case 'xls':
        return 'application/vnd.ms-excel';

      case 'xlsx':
        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

      case 'webm':
        return 'video/webm';

      default:
        return 'application/octet-stream';
    }
  }

  public getImageFromBlob(image: Blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.addEventListener(
        'load',
        () => {
          resolve(reader.result);
        },
        false
      );

      const blob = new Blob([image], { type: 'image/jpeg' });

      if (blob) {
        reader.readAsDataURL(blob);
      } else {
        reject(new Error('Image invalide'));
      }
    });
  }

  // Create and download file
  public downloadFile(data, filename?: string): void {
    let name = filename;
    if (!name) {
      name = this.getFileNameFromHttpResponse(data);
    }

    const mimeType = this.getMimeTypeFromName(name);

    if (!mimeType) {
      return;
    }

    const blob = new Blob([data.body], { type: mimeType });

    const isChrome = window['chrome'] || navigator.userAgent.match('CriOS');
    let type;

    if (isChrome) {
      type = 'createObjectURL';
    } else {
      type = 'readAsDataURL';
    }

    if (navigator.msSaveBlob) {
      // IE11 and Edge 17-
      navigator.msSaveBlob(blob, name);
    } else {
      // every other browser
      const reader = new FileReader();
      reader.onloadend = () => {
        let url;

        switch (type) {
          case 'createObjectURL':
            url = window.URL.createObjectURL(blob);
            break;
          case 'readAsDataURL':
          default:
            url = reader.result;
        }

        this.download(url, name);

        if (type === 'createObjectURL') {
          window.URL.revokeObjectURL(url);
        }
      };

      reader.readAsDataURL(blob);
    }
  }

  // Extract content-disposition headers value
  public getFileNameFromHttpResponse(httpResponse: any): any {
    const contentDispositionHeader = httpResponse.headers.get('content-disposition');
    const result = contentDispositionHeader
      .split(';')[1]
      .trim()
      .split('=')[1];
    return result.replace(/"/g, '');
  }
}
